import { z } from 'zod';
const identifierSchema = z.string().uuid();
const isoDateTimeSchema = z.string().datetime({ offset: true });
export const dietaryProfileStateSchema = z.enum([
    'no_information',
    'declared_none',
    'reported',
    'verified',
    'expired',
    'withdrawn',
    'needs_update',
]);
export const dietaryRestrictionCategorySchema = z.enum([
    'allergen',
    'intolerance',
    'diet',
    'prohibition',
    'religious',
    'ethical',
    'other',
]);
export const dietaryRiskLevelSchema = z.enum([
    'unknown',
    'low',
    'medium',
    'high',
    'critical',
]);
export const dietaryOperationalActionSchema = z.enum([
    'inform',
    'warn',
    'block',
    'requires_decision',
]);
export const dietaryVerificationStateSchema = z.enum([
    'pending',
    'verified',
    'rejected',
    'expired',
]);
export const dietaryProfileSourceSchema = z.enum([
    'self',
    'guardian',
    'staff',
    'import',
]);
export const dietaryRestrictionSchema = z.object({
    id: identifierSchema,
    label: z.string().trim().min(1).max(160),
    category: dietaryRestrictionCategorySchema,
    riskLevel: dietaryRiskLevelSchema,
    operationalAction: dietaryOperationalActionSchema,
    verificationState: dietaryVerificationStateSchema,
    validFrom: isoDateTimeSchema.nullable(),
    validUntil: isoDateTimeSchema.nullable(),
});
export const dietaryProfileSchema = z.object({
    contractVersion: z.literal('1'),
    institutionId: identifierSchema,
    canteenId: identifierSchema,
    consumerId: identifierSchema,
    profileId: identifierSchema.nullable(),
    versionId: identifierSchema.nullable(),
    revision: z.number().int().nonnegative(),
    state: dietaryProfileStateSchema,
    restrictions: z.array(dietaryRestrictionSchema),
    operationalInstruction: z.string().max(500).nullable(),
    source: dietaryProfileSourceSchema.nullable(),
    validFrom: isoDateTimeSchema.nullable(),
    validUntil: isoDateTimeSchema.nullable(),
    verifiedBy: identifierSchema.nullable(),
    verificationComment: z.string().max(500).nullable(),
    updatedAt: isoDateTimeSchema.nullable(),
});
export const upsertDietaryProfileSchema = z
    .object({
    expectedRevision: z.number().int().nonnegative(),
    state: dietaryProfileStateSchema.exclude([
        'no_information',
        'expired',
        'withdrawn',
    ]),
    restrictions: z.array(dietaryRestrictionSchema).max(50).default([]),
    operationalInstruction: z.string().trim().max(500).nullable().default(null),
    source: dietaryProfileSourceSchema,
    validFrom: isoDateTimeSchema.nullable().default(null),
    validUntil: isoDateTimeSchema.nullable().default(null),
    verificationComment: z.string().trim().max(500).nullable().default(null),
})
    .superRefine((value, context) => {
    if (value.state === 'declared_none' && value.restrictions.length > 0) {
        context.addIssue({
            code: 'custom',
            message: 'Deklaracja braku ograniczeń nie może zawierać ograniczeń.',
            path: ['restrictions'],
        });
    }
    if (value.state !== 'declared_none' &&
        value.restrictions.length === 0 &&
        !value.operationalInstruction) {
        context.addIssue({
            code: 'custom',
            message: 'Dodaj ograniczenie lub instrukcję dla personelu.',
            path: ['restrictions'],
        });
    }
    if (value.validFrom &&
        value.validUntil &&
        new Date(value.validUntil) <= new Date(value.validFrom)) {
        context.addIssue({
            code: 'custom',
            message: 'Koniec ważności musi przypadać po początku.',
            path: ['validUntil'],
        });
    }
});
